import { Component, EnvironmentInjector, Inject } from '@angular/core';
import { Modal, ModalOptions } from '@indice/ng-components';
import { AuthService } from 'src/app/core/services/auth.service';
import { RequestsUnauthorizedComponent } from 'src/app/shared/components/requests-unauthorized/requests-unauthorized.component';
import { UnauthorizedRequestsTranslationSuffix } from '../../../shared/components/requests-unauthorized/requests-unauthorized.component';
import * as environment from '../../../core/appSettings';

@Component({
  selector: 'app-service-request-unauthorized-modal',
  standalone: true,
  imports: [RequestsUnauthorizedComponent],
  templateUrl: './service-request-unauthorized-modal.component.html'
})
export class ServiceRequestUnauthorizedModalComponent {
  public unauthorizedSuffix: UnauthorizedRequestsTranslationSuffix = UnauthorizedRequestsTranslationSuffix.REQUEST_SERVICES;
  public redirectUrl: string = '';

  constructor(
    public modalRef: Modal, 
    private _authService: AuthService, 
    @Inject(ModalOptions) private _options: ModalOptions,
    @Inject(EnvironmentInjector) private envInjector: EnvironmentInjector) {
    this.redirectUrl = this._options?.initialState?.['redirectUrl'] as string;
  }

  close() {
    this.modalRef.hide();
  }

  login() {
    this._authService.signinRedirect(this.redirectUrl);
  }

  signUp() {
    var authBasePath = environment.getAppSettings(this.envInjector).auth_settings.authority;
    var portalAuthRedirect = environment.getAppSettings(this.envInjector).auth_settings.post_logout_redirect_uri;
    window.location.href = `${authBasePath}/on-boarding/get-started?returnurl=${portalAuthRedirect}/${this.redirectUrl}`;
  }
}
